import { render, staticRenderFns } from "./CampaignSearch.vue?vue&type=template&id=127b9f34"
import script from "./CampaignSearch.vue?vue&type=script&lang=js"
export * from "./CampaignSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports